<div class="row">
    <div class="col-lg-12">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    #mainGrid
                    appAutoSize
                    [minHeight]="200"
                    (initialized)="grid.initialize(mainGrid); onGridInitialized()"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Mix ID'" [binding]="'structureType'" [width]="150"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Intended Use'" [binding]="'partOfTheStructure'" [width]="150"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Design PSI'" [binding]="'designPsi'" [width]="100"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Supplier'" [binding]="'supplier'" [dataMap]="supplierMap" [width]="150"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Add Mixtures Required'" [binding]="'addMixturesRequired'" [width]="150"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Max Water Ratio'" [binding]="'maxWaterRatio'" [width]="120"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Slump Requirement'" [binding]="'slumpRequirement'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Cylinders Needed'" [binding]="'cylindersNeeded'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Air Requirement'" [binding]="'airRequirement'" [width]="120"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'28 Day Strength'" [binding]="'twentyEightDayStrength'" [width]="120"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Frequency of Samples'" [binding]="'curingReqNumberOfTestRequired'" [width]="150"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Max Lift Height'" [binding]="'maxLifts'" [width]="120"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Max Time on Lifts'" [binding]="'maxTimeOnLifts'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Time to Pour Allowed'" [binding]="'timeToPourAllowed'" [width]="140"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Min Air Temp Required'" [binding]="'minTemperatureRequired'" [width]="150"></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
